var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form__group" }, [
    _c("div", { staticClass: "form__row" }, [
      _c(
        "div",
        { staticClass: "form__multiselect" },
        [
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "duration" } },
            [_vm._v("Duration")]
          ),
          _vm._v(" "),
          _c(
            "multiselect",
            {
              class: {
                form__control: true,
                "form__control--invalid": _vm.errors.first(this.name),
              },
              attrs: {
                id: "duration",
                options: _vm.options,
                placeholder: _vm.placeholder,
                "allow-empty": true,
                label: "label",
                "track-by": "value",
                loading: _vm.loading,
                disabled: _vm.manuallyModified,
              },
              on: { input: _vm.updateValue },
              model: {
                value: _vm.selected,
                callback: function ($$v) {
                  _vm.selected = $$v
                },
                expression: "selected",
              },
            },
            [
              _vm._v("\n                >\n                "),
              _c("span", { attrs: { slot: "noOptions" }, slot: "noOptions" }, [
                _vm._v("Type a name to search durations..."),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _c(
          "label",
          { staticClass: "form__label", attrs: { for: "duration-overwrite" } },
          [_vm._v("Manual Duration")]
        ),
        _vm._v(" "),
        _c("input", {
          staticClass: "form__control form__number",
          attrs: {
            id: "duration-overwrite",
            type: "number",
            disabled: _vm.presetSelected,
          },
          on: { keyup: _vm.manualOverride, mouseup: _vm.manualOverride },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }